import {
  GET_CHANGE_FYE_DETAILS,
  GET_CHANGE_FYE_DETAIL,
  POST_CHANGE_FYE_DETAIL,
  PUT_CHANGE_FYE_DETAIL,
  DELETE_CHANGE_FYE_DETAIL
} from "../constants/actionTypes";

const defaultState = {
  changeFYEArr: [],
  changeFYEDetail: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CHANGE_FYE_DETAILS:
      return { ...state, changeFYEArr: [...action.payload] };
    case GET_CHANGE_FYE_DETAIL:
      return { ...state, changeFYEDetail: { ...action.payload } };
    case POST_CHANGE_FYE_DETAIL:
      return { ...state, changeFYEArr: [...state.changeFYEArr, action.payload] };
    case PUT_CHANGE_FYE_DETAIL:
      return {
        ...state,
        changeFYEArr: state.changeFYEArr.map((item) =>
          item.id === action.payload.id ? { ...action.payload } : item
        )
      };
    case DELETE_CHANGE_FYE_DETAIL:
      return {
        ...state,
        changeFYEArr: state.changeFYEArr.filter((item) => item.id !== action.payload)
      };
    default:
      return state;
  }
};
